import { reportClientError } from '@/api';

/**
 * Перехват uncaught-ошибок и unhandled rejection.
 * Шлёт payload на /api/log/client-error (best-effort). Серверный endpoint
 * не обязан существовать — fetch проглатывает 404.
 */
export function initErrorReporter() {
  window.addEventListener('error', (event) => {
    reportClientError({
      kind: 'error',
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      stack: event.error?.stack,
      url: location.href,
      ua: navigator.userAgent,
      ts: new Date().toISOString(),
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    reportClientError({
      kind: 'unhandledrejection',
      message: typeof reason === 'string' ? reason : reason?.message,
      stack: reason?.stack,
      url: location.href,
      ua: navigator.userAgent,
      ts: new Date().toISOString(),
    });
  });
}
